import ButtonAsLink from './ButtonAsLink';

export * from './ButtonAsLink';

export default ButtonAsLink;
